<template>
  <!-- 取付先検索ダイアログ -->
  <v-dialog v-model="showDialog" width="100vw" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>過去取付先一覧</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>

          <v-row no-gutters>
            <v-col :cols="12">
              <dd-sub-header>
                検索条件
              </dd-sub-header>
              <span class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>過去取引先を絞り込みたい条件を入力して[検索実行]を押下してください。</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="3">
              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                    label="得意先コード/名称"
                    v-model="conditions.tokuisakiId"
                    ref="tokuisakiId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="得意先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    returnValueName="id"
                    :headerList="headersTorihikisakiList"
                    :itemList="filteredTokuisakiList"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="取付先"
                    v-model="conditions.toritsukesakiNm"
                    ref="toritsukesakiNm"
                    :length="50"
                    :valueType="Ctrls.InputTypes.Free"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters justify="end">
                <dd-custom-button
                  color="#2196F3"
                  :rounded="false"
                  :minWidth="100"
                  tooltipText="入力された検索条件で登録済み受付を検索します"
                  :enableToolTip="helpUseFlg"
                  :tooltipBottom="true"
                  @click="onSearchButtonClick">
                  検索実行
                </dd-custom-button>
              </v-row>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="8">
              <dd-sub-header>
                一覧
              </dd-sub-header>
              <span v-if="filteredRows.length > 0" class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>対象行をチェックして[選択]を押下するか、ダブルクリックで呼び出し元画面に反映します。</span>
            </v-col>
            <v-col :cols="4" class="px-1">
              <dd-narrow-down-text-box
                v-model="toritsukesakiSearchText"
                class="pt-4"
                :length="50"
              />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="12" class="px-1">
              <dd-data-table
                calculate-widths
                item-key="id"
                :headers="toritsukesakiHeaders"
                :items="filteredRows"
                height="50vh"
                fixed-header
                locale="ja-jp"
                :search="toritsukesakiSearchText"
                no-data-text="利用可能なデータはありません。"
                hide-default-footer
                @dblclick:row="onRowDoubleClick"
                dense
              >
                <template v-slot:[`item.actions`]="{item}">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </template>
                </template>
              </dd-data-table>
            </v-col>
          </v-row>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          tooltipText="選択せずに画面を閉じます"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
          @click="onCloseButtonClick">
          <v-icon>mdi-window-close</v-icon>
          閉じる
        </dd-footer-button>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdDataTable from '@/components/DdDataTable'
import DdFooterButton from '@/components/DdFooterButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import header from '@/ddv2.library/header'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

export default {
  name: 'TgPopupToritsukesakiSearch',
  mixins: [flowMixin],
  components: {
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdSubHeader,
    DdTextBox
  },
  props: {
    /**
     * 受注明細ID
     */
    id: {
      type: Number,
      default: 0
    },
    /**
     * 取付先名
     */
    toritsukesakiNm: {
      type: String
    },
    /**
     * 得意先ID
     */
    tokuisakiId: {
      type: Number,
      default: null
    },
    /**
     * 画面表示フラグ
     */
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    toritsukesakiSearchText: '',
    rows: [],
    conditions: {
      tokuisakiId: null,
      toritsukesakiNm: null
    },
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    toritsukesakiHeaders: [
      { text: '', value: 'actions' },
      { text: '取付先', value: 'toritsukesakiNm' },
      { text: '営業所', value: 'denpyoBiko1' },
      { text: '担当者', value: 'denpyoBiko2' },
      { text: '電話番号', value: 'denpyoBiko3' },
      { text: '取付先 郵便番号', value: 'toritsukesakiYubinNo' },
      { text: '取付先 住所1', value: 'toritsukesakiJusho1' },
      { text: '取付先 住所2', value: 'toritsukesakiJusho2' },
      { text: '電話番号2', value: 'toritsukesakiJusho3' },
      { text: '取付先備考', value: 'toritsukesakiBiko' },
      { text: '作業場所 郵便番号', value: 'sagyobashoYubinNo' },
      { text: '作業場所 住所1', value: 'sagyobashoJusho1' },
      { text: '作業場所 住所2', value: 'sagyobashoJusho2' },
      { text: '作業場所 住所3', value: 'sagyobashoJusho3' },
      { text: '会社コード', value: 'denpyoBiko6' },
      { text: 'IPアドレス', value: 'denpyoBiko7' },
      { text: 'ポート番号', value: 'denpyoBiko8' },
      { text: '備考', value: 'uketsukeBiko' }
    ]
  }),
  created () {
  },
  mounted () {
    this.clear()
    // this.loadMasters()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredRows () {
      return this.rows.reduce((res, cur) => {
        if (res.every((elem) => elem.toritsukesakiNm !== cur.toritsukesakiNm ||
                                elem.denpyoBiko1 !== cur.denpyoBiko1 ||
                                elem.denpyoBiko2 !== cur.denpyoBiko2 ||
                                elem.denpyoBiko3 !== cur.denpyoBiko3 ||
                                elem.toritsukesakiYubinNo !== cur.toritsukesakiYubinNo ||
                                elem.toritsukesakiJusho1 !== cur.toritsukesakiJusho1 ||
                                elem.toritsukesakiJusho2 !== cur.toritsukesakiJusho2 ||
                                elem.toritsukesakiJusho3 !== cur.toritsukesakiJusho3 ||
                                elem.toritsukesakiBiko !== cur.toritsukesakiBiko)) {
          res.push(cur)
        }
        return res
      }, [])
    },
    // ドロップダウン
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.conditions.tokuisakiId = this.tokuisakiId
        this.conditions.toritsukesakiNm = this.toritsukesakiNm
        if (this.conditions.tokuisakiId !== null) this.search()
      }
    }
  },
  methods: {
    clear: function () {
      this.rows = []
      this.conditions = {
        tokuisakiId: null,
        toritsukesakiNm: null
      }
    },
    loadMasters: function () {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstshubetsu', 'msyskubun', 'msysmessage'], version: 1 }).then(() => {
      })
    },
    search: function () {
      console.log('VwCTgrcod001102 search')
      const self = this
      this.Effects.loadStart()
      return new Promise((resolve) => {
        self.HttpClient
          .post('/api/v1/VwCTgrcod001102/Search', self.conditions)
          .then((data) => {
            console.log('search', data)
            if (data.isValid) {
              self.rows = data.payload
            }
            this.Effects.loadComplete()
            resolve()
          })
          .catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            this.Effects.loadComplete()
            resolve()
          })
      })
    },
    onSearchButtonClick: function () {
      this.search()
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', item)
    },
    onRowDoubleClick: function (e, f) {
      this.$emit('close', f.item)
      this.clear()
    },
    onCloseButtonClick: function (e) {
      this.$emit('close', null)
      this.clear()
    }
  }
}
</script>
<style>
</style>
